import { createTheme } from '@mui/material/styles';
import { APP_BG_COLOR, LIGHT_GREEN, GREEN } from "./webColors";

export const themeConfig = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "MuiFormControl-root": {
            "&:after": {
              borderColor: LIGHT_GREEN
            }
          },
          "& .MuiInput-root": {
            "&:after": {
              borderColor: LIGHT_GREEN,
            },
          },
          "& .MuiInputLabel-standard": {
            "&.Mui-focused": {
              color: LIGHT_GREEN,
            },
          }
        }
      }
    }
  },
  palette: {
    primary: {
      main: LIGHT_GREEN, 
      blue: "#0858f7",     
      black: "#000",
      green: GREEN,   
      smoothDark: "#292929"   
    },    
  },
  typography: {
    fontFamily: [
      'Poppins'
    ].join(','),
  },
  spacing: 5,
  backgroundColor: APP_BG_COLOR,
});